<style lang="less">
  .invakepage{
    width: 287px;
    position: relative;
    margin: 0 auto;
    .title{
      font-size: 24px;
      font-weight: bold;
      color: #000;
    }
    .invake{
      width: 287px;
      background-color: #F7F7F7;
      border-radius: 1px;
      margin: 0 auto;
      margin-top: 24px;
      color:#696464;
      font-size: 15px;
      .invakeTip{
        width: 263px;
        padding: 16px 0;
        border-bottom: 1px solid #D9D9D9;
        margin: 0 auto;
        text-align: left;
      }
      .invakeBtn{
        width: 263px;
        margin:0 auto;
        text-align: left;
        padding:13px 0 12px 0;
        line-height: 22px;
        span{
          color:#30ba78;
          text-decoration: underline;
          font-weight: bold;
          cursor: pointer;
        }
      }
    }
    .signUpByPhone{
      margin-top: 35px;
      // position: absolute;
      // z-index: 2;
      .noInstallClassin{
        width: 287px;
        border-bottom:1px solid #D8D8D8;
        margin:0 auto;
        position: relative;
        span{
          display: inline-table;
          height:20px;
          background-color: #fff;
          text-align:center;
          position: absolute;
          top: 50%;left: 50%;
          transform: translate(-50%,-50%);
          -webkit-transform: translate(-50%,-50%);
          font-size: 17px;
          color:#000;
          padding:0 15px;
        }
      }
      .btn{
        width: 287px;
        background-color: #F2F2F2;
        border-radius: 6px;
        margin: 34px auto 0 auto;
        text-align: left;
        padding:16px 12px;
        span{
          color:#30ba78;
          text-decoration: underline;
          font-weight: bold;
          cursor: pointer;
        }
      }
    }
  }
</style>
<template>
  <div class="invakepage">
    <p class="title">{{$t('pubcourse.jumpPage.starting')}}</p>
    <div class="invake">
      <div class="invakeTip" v-html="$t('pubcourse.jumpPage.openClassIn')"></div>
      <div class="invakeBtn">
        {{$t('pubcourse.jumpPage.browserDontTip')}}
        <span @click="clickRetry">{{$t('pubcourse.jumpPage.clickThis')}}</span>
         {{$t('pubcourse.jumpPage.searchPubcourseId',{pubcourseId: cno})}}
      </div>
    </div>
    <div class="signUpByPhone">
      <div class="noInstallClassin">
        <span>{{$t('pubcourse.jumpPage.dontInstallClassIn')}}</span>
      </div>
      <div class="btn">
        {{$t('pubcourse.jumpPage.by')}}
        <span @click="signUpByPhone">{{$t('pubcourse.jumpPage.signUpByPhone')}}</span>
        {{$t('pubcourse.jumpPage.classInPubcourse')}}
      </div>
      
    </div>
  </div>
</template>

<script>
  export default {
    props:['cno'],
    data(){
      return {
      }
    },
    methods:{
      clickRetry(){
        var url = "classin://www.eeo.cn/enterclass?openCourseId="+this.cno;
        var callBack = ()=>{
          var iframe = document.createElement("iframe");
          iframe.src = url;
          iframe.style.display="none";
          document.body.appendChild(iframe);
          setTimeout(function () {
            iframe.parentNode.removeChild(iframe);
          }, 1000)
        }
        eeoRunWithoutWx(callBack);
      },
      signUpByPhone(){
        window.location.href = window.location.href+"&usePhone=true";
      }
    },
    mounted(){
      setTimeout(()=>{
        this.signUpByPhone();
      }, 15000)
    }
  }
</script>